import type { ReactNode } from 'react'
import { SpacetiMark } from './SpacetiMark'

type BrandRowProps = {
  /**
   * Right-hand slot. The authenticated routes park the account menu here:
   * it belongs to the page, not to the workspace list, and putting it in the
   * chrome keeps the content column down to one question.
   */
  identity?: ReactNode
}

/**
 * Top row of the form pane: mark on the left, account menu on the right.
 *
 * The mark stands alone — no wordmark. Passport carries "spaceti." next to
 * the glyph because a sign-in page has to say whose sign-in page it is; by
 * the Lobby the user is already inside, and the lockup was just weight at
 * the top of the column.
 *
 * The row keeps its height whether or not an identity is passed, so the
 * heading below it lands on the same pixel row on every screen.
 */
export function BrandRow({ identity }: BrandRowProps) {
  return (
    <div className="brandrow">
      <a className="brand" href="https://spaceti.com" aria-label="Spaceti home">
        <SpacetiMark />
      </a>
      {identity}
    </div>
  )
}
